import React from 'react';
import { useTranslation } from 'react-i18next';
import { getRelativeDayName, getRelativeDayString } from '../../core/util/date';
import DateTime from '../DateTime';
import { EN, SupportedLocale } from '../../core/util/localizedStr';

type Props = {
  className?: string;
  appointmentDate: any;
  dayNameClassName?: string;
  timeClassName?: string;
  dateFormat?: string;
  timeFormat?: string;
  shouldShowRelativeDayName?: boolean;
  timeZone?: string;
  locale?: SupportedLocale;
};

const BookingTime = ({
  appointmentDate,
  className,
  dateFormat,
  dayNameClassName,
  shouldShowRelativeDayName = true,
  timeClassName,
  timeFormat = 'h:mma',
  timeZone,
  locale = EN,
}: Props) => {
  const { t } = useTranslation();
  // eslint-disable-next-line no-param-reassign
  dateFormat = dateFormat ?? t('dtFormat.monthAndDate');
  const actualDayName = DateTime.format(appointmentDate, timeZone, { locale })(dateFormat);
  const relativeDay = getRelativeDayName(appointmentDate, timeZone);
  const relativeDayName = getRelativeDayString(relativeDay, t);

  return (
    <div className={className}>
      <div className={dayNameClassName}>
        {shouldShowRelativeDayName ? relativeDayName : ''} {actualDayName}
      </div>

      <div className={timeClassName}>
        <DateTime
          dateTime={appointmentDate}
          format={timeFormat}
          locale={locale}
          timeZone={timeZone}
        />
      </div>
    </div>
  );
};

export default BookingTime;
